// extracted by mini-css-extract-plugin
module.exports = {"container":"MonthsYearsSlider_container__2nmuT","yearDisplay":"MonthsYearsSlider_yearDisplay__14y0n"};